<template>
  <ModalConfirmation
    shouldCloseOnBlur
    :showModal="isOpen"
    :title="headerText"
    @cancel="handleCancel"
  >
    <template v-slot:body>
      <ParagraphBody>
        {{ bodyTextLeader }}
        <b>{{ bodyTextEmphasized }}</b>
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <ButtonSecondary
          :hasOutline="false"
          text="Cancel"
          @click="handleCancel"
        />
        <IconButton
          hasOutline
          icon="delete"
          text="Delete"
          type="error"
          @click="handleDelete"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  ButtonGroup,
  ButtonSecondary,
  IconButton,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'DeleteKeyModal',

  components: {
    ButtonGroup,
    ButtonSecondary,
    IconButton,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    bodyTextEmphasized: {
      type: String,
      required: true,
    },
    headerText: {
      type: String,
      required: true,
    },
    isOpen: Boolean,
  },

  computed: {
    bodyTextLeader() {
      return 'If MFA is required, and this is the only factor, deleting it could lock a user out of their resources. ';
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleDelete() {
      this.$emit('confirm');
    },
  },
};
</script>
